import React, { useEffect } from 'react';
import Select, { ISelectProps, SelectOptionsType } from '.';
import { useApi } from '@gik/core/api';
import Tooltip from '../Tooltip';
import SvgIcon from '../SvgIcon';
import { USState } from '@gik/core/models/gik/USState';

export interface ISelectUSStatesProps extends Omit<ISelectProps, 'options'> {
  type?: 'compact' | 'normal';
  loading?: boolean;
  loadingError?: boolean;
}

const LoadingErrorIndicator = apiError => () => {
  return (
    <Tooltip text={apiError.message}>
      <SvgIcon className="gik-text-error" name="XOutline" />
    </Tooltip>
  );
};

function SelectUSStates({
  type = 'normal',
  placeholder,
  loading,
  loadingError,
  value,
  onChange,
  ...otherProps
}: ISelectUSStatesProps): React.ReactElement {
  // TODO: supply initial data from configuration endpoint
  const { data, error: apiError } = useApi<USState[]>('us-states');
  const [options, setOptions] = React.useState<SelectOptionsType[]>([]);

  const isLoading = loading || !data;

  useEffect(() => {
    if (!data) return;

    setOptions(
      data.map(item => {
        return {
          label: type === 'compact' ? item.abbr : item.name,
          value: item.abbr,
        };
      })
    );
  }, [data]);

  const selectProps = {
    options,
    ...otherProps,
    isLoading,
    placeholder: isLoading ? '' : placeholder,
    value,
    onChange,
  };

  if (apiError || loadingError) {
    selectProps.components = { LoadingIndicator: LoadingErrorIndicator(apiError || loadingError) };
  }

  return <Select {...selectProps} />;
}

// FIXME: forwardRef is breaking select typings
export default React.forwardRef(SelectUSStates);
